import { render, staticRenderFns } from "./statu.vue?vue&type=template&id=35eeb2ce&"
import script from "./statu.vue?vue&type=script&lang=js&"
export * from "./statu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports